// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ngKd","option":"styles_option__3ZwQ2","active":"styles_active__32xrD"};